// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"f4585fb1","48":"1167ba39","116":"69e0c0cd","317":"32a34e88","390":"76bb2fc2","413":"69742e98","574":"2bb5d8ef","872":"732e4a7e","976":"460cc222"}[chunkId] + ".chunk.css";
};